import Header from "./components/header";
import Hero from "./components/hero";
import MainPage from "./components/mainContent";

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <MainPage />
    </div>
  );
}

export default App;
